import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import Container from "./Container";
import LoginLogo from "./Logo";
import RegistrationForm from "./RegistrationForm";
import { setPublicIP } from "../../../helpers/authHelper";

class Registration extends Component {
  constructor(props) {
    super(props);
    setPublicIP();
  }
  render() {
    return (
      <Container>
        <LoginLogo/>
       
          <RegistrationForm/>
         
      </Container>
    );
  }
}

export default Registration;
